
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1kjc7_1u0zp_93",
  "root": "awsui_root_1kjc7_1u0zp_111",
  "title": "awsui_title_1kjc7_1u0zp_127",
  "list": "awsui_list_1kjc7_1u0zp_131",
  "marker--dimmed": "awsui_marker--dimmed_1kjc7_1u0zp_173",
  "marker--highlighted": "awsui_marker--highlighted_1kjc7_1u0zp_176"
};
  